module.exports = __webpack_public_path__ + "img/logo.fd7424da.svg";